import {lazy} from 'react';

export const SpecialistAsync = lazy(() =>
    import('./Specialist')
);
